import { type OptionItem } from "@client/types";
import { isBrowser } from "@common/lib/misc";
import { range } from "lodash";

export interface PaginationInfo {
  currentPage: number;
  isLeftArrowAvailable: boolean;
  isRightArrowAvailable: boolean;
  pageNumbers: number[];
}

export const getPagesCount = (pageSize: number, total: number) => Math.ceil(total / pageSize);

export const getPaginationInfo = (currentPage: number, pagesCount: number): PaginationInfo => {
  const maxPageNumber = Math.min(currentPage + 2, pagesCount);
  let minPageNumber = currentPage;

  for (let i = 1; i < 3 && minPageNumber > 1; i++, minPageNumber--) {}

  return {
    currentPage,
    isLeftArrowAvailable: currentPage > minPageNumber,
    isRightArrowAvailable: currentPage < maxPageNumber,
    pageNumbers: range(minPageNumber, maxPageNumber + 1)
  };
};

export const getPageFromHash = (): number | undefined => {
  if (!isBrowser()) return;

  const match = window.location.hash.match(/\#page(\d+)/);
  return match ? +match[1] : undefined;
};

export const isValidPage = (page: number, pagesCount: number): boolean => page >= 1 && page <= pagesCount;

export const PAGE_SIZES: OptionItem<number>[] = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "25", value: 25 },
  { label: "50", value: 50 },
  { label: "100", value: 100 }
];
